import React from "react"
import Nav from "../components/layout/Nav"
import FirstNav from "../components/layout/FirstNav"
import MainCompetition from "../components/Competition.js/MainCompetition"
import Footer from "../components/layout/Footer"
import Seo from "../components/Seo"

const competition = () => {
    return (
        <>
            <Seo title="Конкурс" />
            <FirstNav />
            <Nav bgNav />
            <MainCompetition />
            <Footer />
        </>
    )
}

export default competition
